var klaviyo = klaviyo || [];
klaviyo.init(window.klaviyo_init_options);
klaviyo.enable("backinstock", window.klaviyo_back_in_stock_options);

const observer = new MutationObserver((mutations, obs) => {
  const iframe = document.querySelector("#klaviyo-bis-iframe");

  if (iframe) {
    obs.disconnect(); // Stop observing once the iframe appears

    iframe.onload = function () {
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

      const form = iframeDoc.querySelector("form");

      form.addEventListener("submit", function (event) {
        Shopify.analytics.publish('back_in_stock_submited', {
          variant_id: Number.parseInt(event.target.querySelector('#variants').value),
          product_id: Number.parseInt(event.target.querySelector('#product').value),
          email: form.querySelector("input[type=email]").value,
        });
      });
    };
  }
});

// Observe document for iframe addition
observer.observe(document.body, { childList: true, subtree: true });